import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../components/commons/CustomBtn";
import Container from "../../components/Container/Container";
import Programmes from "./views/programmes/Programmes";
import Stock from "./views/stock/Stock";
import Lot from "./views/lot/Lot";
import {
  setActiveOnglet,
  deepSearchFunction,
  closeOnglet,
} from "../../redux/actions/immobilierActions";
import { openModal } from "../../redux/actions/modalActions";
import EditSearchModal from "../enregistres/components/EditSearchModal";
import mainAxios from "../../redux/api/mainAxios";

const Immobilier = () => {
  const dispatch = useDispatch();

  const [displayedLot, setDisplayedLot] = useState(null);
  const [totalSubtitle, setTotalSubtitle] = useState("");
  const [changedOnglet, setChangedOnglet] = useState(false);
  const { activeOnglet, onglets } = useSelector(
    (state) => state.immobilierReducer,
  );

  useEffect(() => {
    //initial fetch
    if (activeOnglet.id === "stock") {
      dispatch(deepSearchFunction({}, "stock", "stock", "Stock")).then(
        (res) => {
          setTotalSubtitle(
            `${res.lots.pagination?.total || 0} lots ${
              res.programmes.pagination?.total || 0
            } programmes`,
          );
        },
      );
    }
  }, [dispatch]);
  const onlgetSetter = (ongletId) => {
    setChangedOnglet(!changedOnglet);
    dispatch(setActiveOnglet(ongletId));
  };

  const getPreviousSearch = async (id) => {
    try {
      const response = await mainAxios.get(
        `${process.env.REACT_APP_ENDPOINT_URL}api/search-histories/${id}?populate=*`,
      );

      // Get only the fields that are defined in our formData state
      const apiData = response.data.data;
      const transformedSearch = {
        ...apiData,
        lieu: apiData.lieu ? apiData.lieu.map((location) => location.id) : [],
        programme: apiData.programme
          ? apiData.programme.map((programme) => programme.id)
          : [],
        promoteur: apiData.promoteur
          ? apiData.promoteur.map((promoteur) => promoteur.id)
          : [],
      };
      dispatch(
        openModal({
          title: "Modifier la recherche",
          content: <EditSearchModal searchData={transformedSearch} />,
        }),
      );
      // dispatch(closeModal());
    } catch (error) {
      console.error("Error loading previous search:", error);
    }
  };
  const handleSearchClose = (id) => {
    onlgetSetter("stock");
    dispatch(closeOnglet(id));
  };

  return (
    <Container>
      <div
        className="d-flex gap14 hideScrollbar pt-3"
        style={{ overflowX: "scroll", maxWidth: "80%" }}
      >
        {onglets.map((onglet) => (
          <div className="position-relative" key={onglet.id}>
            {onglet.type !== "stock" && (
              <button
                className="position-absolute close-button"
                onClick={() => handleSearchClose(onglet.id)}
              >
                ×
              </button>
            )}
            <CustomButton
              onClick={() => onlgetSetter(onglet.id)}
              label={onglet.name}
              subtitle={onglet.id === "stock" ? totalSubtitle : onglet.subtitle}
              contentLengthClass={`${
                activeOnglet.id === onglet.id
                  ? "regular fs11 pink "
                  : "regular fs11 white"
              } `}
              buttonClass={`${
                activeOnglet.id === onglet.id
                  ? "bg-white radiusTop5 px-20 py-10 "
                  : "bg-pink radiusTop5 px-20 py-10 white"
              } `}
              labelClass={`text-ellipsis ${
                activeOnglet.id === onglet.id
                  ? "pink fs16 semibold text-capitalize text-start"
                  : "white fs16 semibold text-capitalize text-start"
              }`}
              showModifyIcon={onglet.showModifyIcon || false}
              isActive={activeOnglet.type === "search"}
              onModifyClick={() => getPreviousSearch(onglet.id)}
            />
          </div>
        ))}
      </div>

      {activeOnglet.type !== "programme" &&
        activeOnglet.type !== "lot" &&
        activeOnglet.type && (
          <Stock
            //programmes
            listeDesProgrammes={activeOnglet.programmes}
            programmeListMap={
              activeOnglet.programmeListMap || activeOnglet.programmes
            }
            programmeListMapPagination={
              activeOnglet.programmeListMapPagination ||
              activeOnglet.programmesPagination
            }
            programmesPagination={activeOnglet.programmesPagination}
            programmesCoordinates={activeOnglet.programmesCoordinates}
            loading={activeOnglet.loading}
            error={activeOnglet.error}
            query={activeOnglet.query}
            ongletType={activeOnglet.type}
            ongletId={activeOnglet.id}
            ongletName={activeOnglet.name}
            //lots
            listesLots={activeOnglet.lots}
            lotsPagination={activeOnglet.lotsPagination}
            changedOnglet={changedOnglet}
          />
        )}

      {activeOnglet.type === "programme" && (
        <Programmes
          key={activeOnglet.id}
          programmeId={activeOnglet.id}
          displayedLot={displayedLot}
          setDisplayedLot={setDisplayedLot}
        />
      )}

      {activeOnglet.type === "lot" && (
        <Lot
          key={activeOnglet.id}
          lotId={activeOnglet.id}
          lotData={activeOnglet.lot}
          setDisplayedLot={setDisplayedLot}
        />
      )}
    </Container>
  );
};

export default Immobilier;
